import { NgModule } from '@angular/core';
import { AddEditComponent } from './add-edit/add-edit.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {ExcelUploadComponent} from './excel-upload-component/excel-upload-component.component';
import {MyProductsModule} from '../my-products/my-products.module';
import { OrderAdminComponent } from './order-admin/order-admin.component';
import {BrowserModule} from '@angular/platform-browser';
import {HttpClientModule} from '@angular/common/http';

@NgModule({
    declarations: [
        AddEditComponent,
        ExcelUploadComponent,
        OrderAdminComponent
    ],
    imports: [
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        MyProductsModule,


      BrowserModule,
      HttpClientModule,

    ],
  exports: [
    SharedModule,
    MyProductsModule
  ]})
export class AdminModule {}
